module.exports = __webpack_public_path__ + "img/package-4.f1a46f9a.png";